import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faXmark } from '@fortawesome/free-solid-svg-icons';

export default function ConfirmModal({
  open,
  title,
  description,
  confirmLabel = 'Delete Permanently',
  cancelLabel = 'Cancel',
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div style={s.overlay} onClick={e => e.target === e.currentTarget && onCancel?.()}>
      <div style={s.modal} role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
        <div style={s.header}>
          <div style={s.iconWrap}>
            <FontAwesomeIcon icon={faTriangleExclamation} aria-hidden="true" />
          </div>
          <button onClick={onCancel} style={s.closeBtn} aria-label="Close dialog">
            <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
          </button>
        </div>
        <h3 id="confirm-modal-title" style={s.title}>{title}</h3>
        <p style={s.desc}>{description}</p>
        <div style={s.actions}>
          <button onClick={onCancel} style={s.cancelBtn}>{cancelLabel}</button>
          <button onClick={onConfirm} style={s.confirmBtn}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.55)',
    backdropFilter: 'blur(6px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
  },
  modal: {
    width: 'min(92vw, 460px)',
    background: 'var(--bg-secondary)',
    border: '1px solid var(--border)',
    borderRadius: 20,
    padding: 22,
    boxShadow: 'var(--shadow-lg)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 14,
  },
  iconWrap: {
    width: 42,
    height: 42,
    borderRadius: 14,
    background: 'rgba(245, 158, 11, 0.14)',
    color: '#f59e0b',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
  },
  closeBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    border: '1px solid var(--border)',
    background: 'var(--bg-tertiary)',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
  },
  title: {
    fontSize: 18,
    fontWeight: 800,
    color: 'var(--text-primary)',
    marginBottom: 8,
    lineHeight: 1.4,
  },
  desc: {
    fontSize: 14,
    lineHeight: 1.7,
    color: 'var(--text-secondary)',
    marginBottom: 18,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
  },
  cancelBtn: {
    padding: '10px 16px',
    borderRadius: 10,
    border: '1px solid var(--border)',
    background: 'var(--bg-primary)',
    color: 'var(--text-primary)',
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
  },
  confirmBtn: {
    padding: '10px 16px',
    borderRadius: 10,
    border: 'none',
    background: '#dc2626',
    color: '#fff',
    fontSize: 13,
    fontWeight: 800,
    cursor: 'pointer',
  },
};
